// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".InstagramCard__iframe___2Jb5K{height:605px;border-radius:8px}@media (max-width:1279px){.InstagramCard__iframe___2Jb5K{height:555px}}@media (max-width:719px){.InstagramCard__iframe___2Jb5K{height:525px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"xsmall": "540px",
	"small": "720px",
	"medium": "960px",
	"large": "1280px",
	"iframe": "InstagramCard__iframe___2Jb5K"
};
module.exports = ___CSS_LOADER_EXPORT___;
